import {ComWixEcomMembershipsSpiV1HostMembership} from '../../../../gql/graphql';

export class SelectedMembershipModel {
  public name: string;

  constructor(params: SelectedMembershipModel) {
    this.name = params.name;
  }

  public static fromCheckoutV1(selectedMembership?: ComWixEcomMembershipsSpiV1HostMembership) {
    if (!selectedMembership) {
      return undefined;
    }
    return new SelectedMembershipModel({
      name: selectedMembership.name?.original ?? /* istanbul ignore next */ '',
    });
  }
}
